import React, { useState } from "react";
import { BaseUrl } from "../helper/BaseUrl";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../myIcon/Icons";

export default function Footer({ footerHide }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
  const [formData, setFormData] = useState({
    email: "",
    source_url: sourceUrl,
    // current_url: currentUrl,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      source_url: sourceUrl,
      // current_url: currentUrl,
      [name]: value,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     const response = await fetch(`${BaseUrl}/api/newslatter-saves`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(formData),
  //     });

  //     const result = await response.json();

  //     if (result.success === true) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         email: "",
  //       }));

  //       navigate("/thankyou");
  //     } else {
  //       toast.error(result.message);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("Something went wrong while submitting the form.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormData((prev) => ({
      ...prev,
      email: "",
    }));

    navigate("/thankyou");
  };

  return (
    <>
      <footer className={`footer ${footerHide || ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-12">
                  <div className="footer-logo">
                    <div>
                      <img src="/image/logo.webp" className="img-responsive" alt="Logo" loading="lazy" />
                    </div>

                    <div>
                      <label className="footer-linkhead">Enquire</label>
                      <ul className="footer-info">
                        <li>
                          <Link to="mailto:info@sonamlabel.com">info@sonamlabel.com</Link>
                        </li>
                        <li>
                          <Link to="tel:+919552221979">(+91) 955 222 1979</Link>
                        </li>
                      </ul>
                    </div>

                    <div>
                      <label className="footer-linkhead">Office</label>
                      <p>Lodha Belmondo, Tower 11, Pune, Maharashtra</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3 col-6">
                  <label className="footer-linkhead">Quick Links</label>
                  <ul className="footer-links">
                    <li>
                      <Link to={"/about-us"}>About</Link>
                    </li>
                    <li>
                      <Link to={"/collaboration"}>Collaboration</Link>
                    </li>
                    <li>
                      <Link to={"/craft-preservation"}>Craft Preservation</Link>
                    </li>
                    <li>
                      <Link to={"/our-process"}>Our Process</Link>
                    </li>
                    <li>
                      <Link to={"/blog"}>Blog</Link>
                    </li>
                    <li>
                      <Link to={"/contact"}>Contact</Link>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-3 col-md-3 col-6">
                  <label className="footer-linkhead">Collections</label>
                  <ul className="footer-links">
                    <li>
                      <Link to={"/contemporary"}>Contemporary</Link>
                    </li>
                    <li>
                      <Link to={"/haldi-dresses"}>Haldi</Link>
                    </li>
                    <li>
                      <Link to={"/mehandi-dresses"}>Mehandi</Link>
                    </li>
                    <li>
                      <Link to={"/sangeet-suit"}>Sangeet</Link>
                    </li>
                    <li>
                      <Link to={"/wedding-dress-designers"}>Wedding</Link>
                    </li>
                    <li>
                      <Link to={"/festive-wear"}>Festive</Link>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-3 col-md-3 col-12">
                  <div className="footer-subscribe">
                    <label className="footer-linkhead">Stay in the loop!</label>
                    <p>Get our monthly newsletter and special subscriber offers sent right to your inbox.</p>
                    <form onSubmit={handleSubmit}>
                      <input
                        value={formData.email}
                        onChange={handleChange}
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        className="form-control"
                      />
                      <button type="submit" className="default-btn red-default">
                        {loading ? "submitting..." : "Subscribe Now"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ul className="footer-social">
          <li>
            <Link to={"https://www.facebook.com/profile.php?id=61561567174333"} target="_blank" aria-label="Facebook">
              <Icons name="facebook" />
            </Link>
          </li>
          <li>
            <Link to={"https://www.instagram.com/sonamslabel"} target="_blank" aria-label="instagram">
              <Icons name="instagram" />
            </Link>
          </li>
          <li>
            <Link to={"https://www.pinterest.com/sonamlabel"} target="_blank" aria-label="pinterest">
              <Icons name="pinterest" />
            </Link>
          </li>
          <li>
            <Link to={"https://www.youtube.com/@SonamLabel"} target="_blank" aria-label="youtube">
              <Icons name="youtube" />
            </Link>
          </li>
        </ul>

        <p className="footer-copyright">
          © 2025 All rights reserved by <span>Sonam Label</span>
        </p>
      </footer>
    </>
  );
}
